const TransactionTypes = {
    COLLECTION : "COLLECTION",
    REDEMPTION : "REDEMPTION",
    ADJUSTMENT : "ADJUSTMENT"
}

export default TransactionTypes;